import { render, staticRenderFns } from "./indexLive.vue?vue&type=template&id=b579d534&scoped=true"
import script from "./indexLive.vue?vue&type=script&lang=ts"
export * from "./indexLive.vue?vue&type=script&lang=ts"
import style0 from "./indexLive.vue?vue&type=style&index=0&id=b579d534&prod&lang=scss&scoped=true"
import style1 from "./indexLive.vue?vue&type=style&index=1&id=b579d534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b579d534",
  null
  
)

export default component.exports